import React from "react";
import kingdomImg from '../../assets/logo_kingdom_256px.png';

function ValoresCorporativosEjemplares() {
    return (
        <div>
            <div className="navbar navbar-dark bg-dark m-0 p-0 py-1">
                        <div className="container-fluid ">
                            <div className="navbar-brand card flex-row bg-dark m-0 p-0" >
                                <img src={kingdomImg} width="50" className="d-inline-block align-text-top card-img-left my-auto" />
                                <div className='ps-2 my-auto d-none d-sm-inline'>
                                    <div className="cargoHeader lh-sm">Chicken's<br></br>Kingdom</div>
                                </div>
                            </div>
                            <div className='text-light fw-bold fs-6 text-uppercase'>Valores Corporativos Ejemplares</div> 
                        </div>
        </div>
            <div>
                                 <h1>ValoresCorporativosEjemplares</h1>
                                     <p>Aquí va todo el contenido de la Valores Corporativos Ejemplares...</p>
                                    {/* O tu HTML / React que representa la ValoresCorporativosEjemplares */}
                                </div>
        </div>
        
    );
}

export default ValoresCorporativosEjemplares;